import {
  pageListQuery, pageQuery, query
} from '@/services/internal/Stock';
import { queryQpcAdjStocks } from "@/services/internal/StockAdjBill";
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'stock',

  state: {
    stockPageQuery: {},
    stocks: [],
    data: {
      list: [],
      pagination: {},
    },
    stockLinePageMap: new Map(),
    stockLineMap: new Map(),//使用map精确缓存每一行明细历史数据
  },

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
      if (response && response.success) {
        yield put({
          type: 'save',
          payload: {
            stocks: response.data ? response.data : [],
            line: payload.line
          }
        });
      }

    },
    *clearStocks({ }, { call, put }) {
      yield put({
        type: 'clear'
      });
    },
    *simpleStockPage({ payload, callback }, { call, put }) {
      const response = yield call(pageQuery, payload);
      if (callback) callback(response);
    },
    *pageQuery({ payload, callback }, { call, put }) {
      const response = yield call(pageQuery, payload);
      if (response.success) {
        yield put({
          type: 'saveQueryResult',
          payload: {
            line: payload.line,
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    * queryQpcAdjStocks({ payload, callback }, { call, put }) {
      const response = yield call(queryQpcAdjStocks, payload);
      if (response.success) {
        yield put({
          type: 'saveQueryResult',
          payload: {
            line: payload.line,
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *pageListQuery({ payload, callback }, { call, put }) {
      const response = yield call(pageListQuery, payload);
      if (response && response.success) {
        yield put({
          type: 'savePageListQuery',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },

  },

  reducers: {
    save(state, action) {
      let stockLineMap = state.stockLineMap ? state.stockLineMap : new Map();
      if (action.payload.stocks && action.payload.line) {
        stockLineMap.set(action.payload.line, action.payload.stocks);
      }
      return {
        ...state,
        stocks: action.payload.stocks,
        stockLineMap: stockLineMap
      };
    },
    clear(state, action) {
      return {
        ...state,
        stocks: [],
        stockLineMap: new Map(),
        stockLinePageMap: new Map()
      };
    },
    saveQueryResult(state, action) {
      let stockLinePageMap = state.stockLinePageMap ? state.stockLinePageMap : new Map();
      if (action.payload && action.payload.line) {
        let data = action.payload;
        stockLinePageMap.set(action.payload.line, data);
      }

      return {
        ...state,
        data: action.payload,
        stockLinePageMap: stockLinePageMap
      };
    },
    savePageListQuery(state, action) {
      return {
        ...state,
        stockPageQuery: action.payload
      }
    },
  }
}
